export const getUserIdFromToken = (): string | null => {
  const token = localStorage.getItem("access_token");
  if (!token) return null;

  try {
    const base64Payload = token.split(".")[1];
    const decodedPayload = JSON.parse(atob(base64Payload)) as {
      sub?: string;
      id?: string;
    };

    return decodedPayload.sub ?? decodedPayload.id ?? null;
  } catch (error) {
    console.error("Failed to parse token:", error);
    return null;
  }
};
